// extracted by mini-css-extract-plugin
module.exports = {"footer":"MainFooter_footer__2AJDa"};